import React, {Component} from 'react';
import Modal from '../../components/UI/Modal/Modal';
import Auxiliary from '../Auxiliary/Auxiliary';

const withErrorHandler = (WrappedComponent, axios) => {
    return class extends Component {
        state = {
            error: null
        }
        componentDidMount() {
           this.reqInterceptor = axios.interceptors.request.use(req => {
                this.setState({error: null});
                return req;
            } ) 
            this.resInterceptor = axios.interceptors.response.use(res => res, error => {
                this.setState({error: error});
            });
        }

        componentWillUnmount() {
            //interceptors DO WORK and don't need CompWillMount to run
            axios.interceptors.request.eject(this.reqInterceptor);
            axios.interceptors.response.eject(this.resInterceptor);
        }

//new method nhdlr for getting rid of modal on clicked
errorConfirmedHndlr = () => {
    this.setState({error: null }) 
}

    render() {
        return (
        <Auxiliary> 
          <Modal 
            show={this.state.error}
            modalClosed={this.errorConfirmedHndlr}>
       {this.state.error ? this.state.error.message : null} 
            </Modal>
        <WrappedComponent {...this.props} />
        </Auxiliary>
       );
   }
 }
}

export default withErrorHandler;